import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { FieldType } from "../../type-system/FieldType";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { ConnectionModelSpecVersion, buildConnectionSpec } from "./ShopifyMetadata";
import {
  ShopifyFeaturedProductMediaToProductKey,
  ShopifyFileKey,
  ShopifyProductKey,
  ShopifyProductMediaIdKey,
  ShopifyProductMediaKey,
  ShopifyProductMediaToFileKey,
  ShopifyProductMediaToProductKey,
  ShopifyProductMediaToShopKey,
  ShopifyShopKey,
} from "./keys";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyProductMediaKey,
  defaultFilterableApiIdentifiers: ["position"],
  "2024-07": {
    name: "Shopify Product Media",
    fields: [
      {
        name: "ID",
        key: ShopifyProductMediaIdKey,
        fieldType: FieldType.ID,
        dominionID: GadgetSystemDominionId,
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductMediaToProductKey,
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "product_id",
            graphQLFieldKey: "productId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "File",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductMediaToFileKey,
        configuration: {
          relatedModelKey: ShopifyFileKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "file_id",
            graphQLFieldKey: "fileId",
            inheritSelectionFrom: ShopifyFileKey,
            skipGraphQLFragments: ["GenericFile"],
          },
        },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "position", graphQLFieldKey: "position", skipGraphQLSelection: true },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductMediaToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
      {
        name: "Featured Media For Product",
        key: ShopifyFeaturedProductMediaToProductKey,
        fieldType: FieldType.BelongsTo,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "featuredMediaForProduct",
            skipGraphQLSelection: true,
            shopifyFieldKey: "featured_media_for_product",
          },
        },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
    ],
    syncConfig: { type: "graphql_sublist", parent: "products", resource: "product.media" },
  },
};

export const ShopifyProductMedia = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
